import React from 'react'
import SmallSection from '../../../../../../Components/SmallSection'

const formatDay = day => (day ? day.charAt(0) + day.slice(1).toLowerCase() : '')

const PreScreeningSection = ({ data }) => {
  const { workAuthorized, availableDays, area, createdAt } = data

  const userInfo = [
    workAuthorized ? 'Yes' : 'No',
    (availableDays || []).map(formatDay).join(', ') || '-',
    area || '-',
    createdAt
      ? new Date(Number(createdAt) || createdAt).toLocaleDateString()
      : '-',
  ]

  const columns = [
    {
      id: 1,
      columnName: 'Authorized to work',
    },
    {
      id: 2,
      columnName: 'Available days',
    },
    {
      id: 3,
      columnName: 'Area',
    },
    {
      id: 4,
      columnName: 'Answered on',
    },
  ]

  return (
    <SmallSection title="Pre-screening" columns={columns} data={userInfo} />
  )
}

export default PreScreeningSection
